<template>
	<div>
		<component v-bind:is="currentComponent" v-bind="componentProps" v-on="componentListeners"></component>
	</div>
</template>

<script>
import { PARAM_TYPES_MAP } from './block-editor-params.const';
import { buildListenersObject } from '@/utils/helpers';

export default {
	name: 'ParamDispatcher',
	props: {
		param: { type: Object },
		node: { type: Object },
		nodeService: { type: Object },
		nodeAction: { type: Object },
		workflowVersion: { type: Object },
		disabled: { type: Boolean, default: false },
		hasEditPermissions: { type: Boolean, default: false },
	},
	computed: {
		currentComponent() {
			return PARAM_TYPES_MAP[this.param.type] || PARAM_TYPES_MAP.default;
		},
		componentProps() {
			return {
				param: this.param,
				service: this.nodeService,
				node: this.node,
				action: this.nodeAction,
				workflowVersion: this.workflowVersion,
				disabled: this.disabled,
				readonly: !this.hasEditPermissions,
			};
		},
		componentListeners() {
			const UPDATE_INPUT_FIELD = 'update-input-field';
			const UPDATE_INPUT_FIELD_LABEL = 'update-input-field-label';
			const UPDATE_INPUT_FALLBACK = 'update-input-fallback';
			const listenersFunctions = [UPDATE_INPUT_FIELD, UPDATE_INPUT_FIELD_LABEL, UPDATE_INPUT_FALLBACK];
			return buildListenersObject(this, listenersFunctions);
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="scss" scoped></style>
